import { getProducts, setMindboxProductList } from './utils/graphql';

document.addEventListener('DOMContentLoaded', () => {
	const $startTestBtn = document.querySelector('[data-role=start-btn]') as HTMLElement;
	const $testStartContent = document.querySelector('[data-role=test-start-content]') as HTMLElement;
	const $testResultContent = document.querySelector('[data-role=test-result-content]') as HTMLElement;
	const $testMainContent = document.querySelector('[data-role=test-main-content]') as HTMLElement;
	const $nextTestBtn = document.querySelector('[data-role=test-btn-next]') as HTMLElement;
	const $testQuestionsContent = document.querySelectorAll('[data-role=test-questions-content]') as NodeListOf<HTMLElement>;
	const $testBtnResult = document.querySelector('[data-role=test-btn-result]') as HTMLElement;
	const $testPage = document.querySelectorAll('[data-role=test-page]') as NodeListOf<HTMLElement>;
	const $testBackLink = document.querySelector('[data-role=test-back-link]') as HTMLElement;
	const $testAnswer = document.querySelectorAll('[data-role=test-answer]') as NodeListOf<HTMLElement>;
	const $testThankContent = document.querySelector('[data-role=test-thank-content]') as HTMLElement;
	const $testBtnRestart = document.querySelector('[data-role=test-btn-restart]') as HTMLElement;
	const $testResultProducts = $testResultContent.querySelectorAll('[data-role=product-item]') as NodeListOf<HTMLElement>;
	const $testBtnRoutines = document.querySelector('[data-role=test-btn-routines]') as HTMLElement;
	const $testResultParts = document.querySelectorAll('[data-role=test-result-part]') as NodeListOf<HTMLElement>;
	const $testSubscriptionForm = document.querySelector('[data-role=test-subscription-form]') as HTMLElement;
	const $testSubscriptionThankMsg = document.querySelector('[data-role=test-subscription-thank-msg]') as HTMLElement;

	type MindboxCategoryDataRaw = {
		[category: string]: string[]; // массив SKU
	};
	
	const mindboxDataRaw: MindboxCategoryDataRaw = {
		cleansing_etat_pur: [],
		active_care_etat_pur: [],
		moisturizing_etat_pur: [],
		sun_protection_etat_pur: [],
	};

	const mindboxMainProblemsSet = new Set<string>();
	const testResultsSet = new Set<string>();
	let currentPage = 1;

	const goToFirstSlideResultRoutineEvent = new Event('goToFirstSlideResultRoutine');

	$testBtnResult.classList.add('_disable');

	$startTestBtn.addEventListener('click', onStartTestBtnClick);
	$nextTestBtn.addEventListener('click', onNextTestBtnClick);
	$testBackLink.addEventListener('click', onTestBackLink);
	$testBtnResult.addEventListener('click', onTestBtnResult);
	$testBtnRestart.addEventListener('click', onTestBtnRestart);
	$testBtnRoutines.addEventListener('click', onTestBtnRoutines);
	$testSubscriptionForm.addEventListener('submit', onTestSubscriptionFormSubmit);

	$testPage.forEach(($el) => $el.addEventListener('click', (event: Event) => {
		event.preventDefault();

		const targetPage = Number($el.getAttribute('data-page-number'));

		if (targetPage > currentPage) {
			if (currentPage === 1 && $nextTestBtn.classList.contains('_disable')) {
			  return;
			}

			if (currentPage === 2 && $testBtnResult.classList.contains('_disable')) {
			  return;
			}
		}

		if ($el.classList.contains('_active')) {
			return;
		}

		changeTestContent(targetPage);

		currentPage = targetPage;
	}));

	$testAnswer.forEach(($el) => $el.addEventListener('click', (event: Event) => {
		event.preventDefault();

		onAnswerClick(event);
	}));

	function onStartTestBtnClick(event: Event) {
		event.preventDefault();

		$testStartContent.classList.remove('_active');
		$testMainContent.classList.add('_active');

		updateButtonState(1);
	}

	function onNextTestBtnClick(event: Event) {
		event.preventDefault();

		const $target = event.currentTarget as HTMLElement;
		const pageNumber = $target.getAttribute('data-page-number');
		const nextPageNumber = Number(pageNumber) + 1;

		changeTestContent(nextPageNumber);
	}

	function onTestBackLink(event: Event) {
		event.preventDefault();

		const $target = event.currentTarget as HTMLElement;
		const pageNumber = $target.getAttribute('data-page-number');

		if (Number(pageNumber) === 1) {
			$testMainContent.classList.remove('_active');
			$testStartContent.classList.add('_active');
		} else {
			changeTestContent(Number(pageNumber) - 1);
		}
	}

	function onTestBtnResult(event: Event) {
		event.preventDefault();

		const anySelected = Array.from($testAnswer).some(
			($el) => $el.getAttribute('data-selected') === 'true'
		);

		if (!anySelected) {
			$testBtnResult.classList.add('_disable');

			return;
		}

		fillResults();
		combineMindboxData();

		$testMainContent.classList.remove('_active');
		$testThankContent.classList.add('_active');
		$testBtnResult.classList.remove('_disable');

		$testThankContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	function onTestBtnRoutines(event: Event) {
		event.preventDefault();

		showResultProducts();
		
		if (!$testResultContent.classList.contains('_active')) {
			$testResultContent.classList.add('_active');
		}

		$testResultContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	function onTestBtnRestart(event: Event) {
		event.preventDefault();

		$testAnswer.forEach(($el) => {
			deselectAnswer($el);
		});

		testResultsSet.clear();
		mindboxMainProblemsSet.clear();
		$testSubscriptionForm.classList.add('_active');
		$testSubscriptionThankMsg.classList.remove('_active');

		$testResultContent.classList.remove('_active');
		$testResultParts.forEach($part => $part.classList.remove('_active'));

		$nextTestBtn.classList.add('_disable');
		$testBtnResult.classList.add('_disable');

		$testThankContent.classList.remove('_active');
		$testMainContent.classList.add('_active');

		changeTestContent(1);
		updateButtonState(1);

		window.dispatchEvent(goToFirstSlideResultRoutineEvent);
	}

	function changeTestContent(nextPageNumber) {
		currentPage = nextPageNumber;
		
		$testQuestionsContent.forEach(($_el) => {
			$_el.classList.remove('_active');
			Number($_el.getAttribute('data-page-number')) === nextPageNumber  && $_el.classList.add('_active');
		});

		$testPage.forEach(($_el) => {
			$_el.classList.remove('_active');
			Number($_el.getAttribute('data-page-number')) === nextPageNumber && $_el.classList.add('_active');
		});

		$testBackLink.setAttribute('data-page-number', String(nextPageNumber));

		if (nextPageNumber === 1) {
			$testBtnResult.classList.remove('_active');
			$nextTestBtn.classList.add('_active');
		} else if (nextPageNumber === 2) {
			$nextTestBtn.classList.remove('_active');
			$testBtnResult.classList.add('_active');

			updateButtonState(nextPageNumber);
		}
	}

	function onAnswerClick(event: Event) {
		const $target = event.currentTarget as HTMLElement;
		const $closestQuestionContent = $target.closest('[data-role=test-questions-content]');
		const restrictNumber = Number($closestQuestionContent?.getAttribute('data-restrict-number')) || 1;
		const $currentTestAnswers = $closestQuestionContent?.querySelectorAll('[data-role=test-answer]') || [];

		const isSelected = $target.getAttribute('data-selected') === 'true';
		const selectedCount = Array.from($currentTestAnswers).filter(el => el.getAttribute('data-selected') === 'true').length;

		if (restrictNumber === 1) {
			$currentTestAnswers.forEach((answer) => deselectAnswer(answer));

			selectAnswer($target);
		} else {
			if (isSelected) {
				deselectAnswer($target);
			} else if (selectedCount < restrictNumber) {
				selectAnswer($target);
			}
		}

		const currentPage = Number($closestQuestionContent?.getAttribute('data-page-number')) || 1;

		updateButtonState(currentPage);
	}

	function getSelectedQ1Type(): string | null {
		const $q1 = document.querySelector('[data-role=test-questions-content][data-page-number="1"]');
		const $selected = $q1?.querySelector('[data-role=test-answer][data-selected="true"]');

		return $selected?.getAttribute('data-answer-type') || null;
	}

	function fillResults() {
		const q1Type = getSelectedQ1Type();

		$testAnswer.forEach($el => {
			if ($el.getAttribute('data-selected') === 'true') {
				const dataResults = JSON.parse($el.getAttribute('data-results') || '[]');
				const dataMainProblem = $el.getAttribute('data-main-problem');

				dataResults.forEach((result) => {
					if (result.ifQ1Type && result.ifQ1Type !== q1Type) return;
					if (result.unlessQ1Type && result.unlessQ1Type === q1Type) return;

					let products = result.products;

					if (result.randomizeProducts) {
						products = randomizeProducts(result.products, result.randomizeProducts);
					}

					products.forEach(product => {
						testResultsSet.add(product);
					});
				});

				dataMainProblem && mindboxMainProblemsSet.add(dataMainProblem);
			}
		});
	}

	function showResultProducts() {
		$testResultProducts.forEach($el => {
			const sku = $el.querySelector<HTMLElement>('form[data-role="add-to-cart-form"]')?.dataset.sku
				|| $el.dataset.sku;

			if (!sku || !testResultsSet.has(sku)) return;

			$el.closest('[data-role=test-result-part]')?.classList.add('_active');
		});
	}

	function selectAnswer($el: HTMLElement) {
		$el.classList.add('_active');
		$el.setAttribute('data-selected', 'true');
	}
	
	function deselectAnswer($el: HTMLElement) {
		$el.classList.remove('_active');
		$el.setAttribute('data-selected', 'false');
	}

	function anyAnswerSelectedOnPage(pageNumber: number): boolean {
		const $questionContent = document.querySelector(`[data-role=test-questions-content][data-page-number="${pageNumber}"]`);
		
		if (!$questionContent) return false;
	
		const $answers = $questionContent.querySelectorAll('[data-role=test-answer]');

		return Array.from($answers).some($el => $el.getAttribute('data-selected') === 'true');
	}

	function updateButtonState(pageNumber: number) {
		if (pageNumber === 1) {
			const disableNext = !anyAnswerSelectedOnPage(pageNumber);

			$nextTestBtn.classList.toggle('_disable', disableNext);

			$testPage.forEach($el => {
				if ($el.getAttribute('data-page-number') === '1') {
				  $el.classList.toggle('_disabled', disableNext);
				}
			  });
		} else if (pageNumber === 2) {
			$testBtnResult.classList.toggle('_disable', !anyAnswerSelectedOnPage(pageNumber));
		}
	}

	function randomizeProducts(arrayIds, number) {
		const copyArrayIds = [...arrayIds];

		for (let i = copyArrayIds.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[copyArrayIds[i], copyArrayIds[j]] = [copyArrayIds[j], copyArrayIds[i]];
		}
		
		return copyArrayIds.slice(0, number);
	}

	function combineMindboxData() {
		Object.keys(mindboxDataRaw).forEach(key => (mindboxDataRaw[key] = []));

		$testResultProducts.forEach($el => {
			const sku = $el.querySelector<HTMLElement>('form[data-role="add-to-cart-form"]')?.dataset.sku
				|| $el.dataset.sku;
	
			const category = $el.dataset.mindboxCategory;
	
			if (!sku || !testResultsSet.has(sku) || !category) return;
	
			mindboxDataRaw[category]?.push(sku);
		});
	}

	async function onTestSubscriptionFormSubmit(event: Event) {
		event.preventDefault();
	
		const $form = event.target as HTMLFormElement;
	
		if ($form.dataset.role !== 'test-subscription-form') {
			return;
		}

		const $emailInput = $form.querySelector<HTMLInputElement>('input[name="email"]');
  	const $checkbox = $form.querySelector<HTMLInputElement>('input[name="subscription"]');

		const $emailError = $form.querySelector('[data-role="error-email"]');
  	const $checkboxError = $form.querySelector('[data-role="error-checkbox"]');

		$emailError?.classList.remove('_visible');
		$checkboxError?.classList.remove('_visible');
		$emailInput?.classList.remove('_error');

		let isValid = true;

		if (!$emailInput?.checkValidity()) {
			$emailInput?.classList.add('_error');
			$emailError?.classList.add('_visible');
			isValid = false;
		}

		if (!$checkbox?.checked) {
			$checkboxError?.classList.add('_visible');
			isValid = false;
		}

		if (!isValid) return;
	
		const email = $emailInput!.value.trim();
  	const is_subscribed = $checkbox!.checked;

		const allSkus = Array.from(testResultsSet);
		if (!allSkus.length) return;

		try {
			const products = await getProducts(allSkus);
			const mindboxDataFinal: Record<string, { mindbox_id: string; price: number }[]> = {};

			Object.entries(mindboxDataRaw).forEach(([category, skus]) => {
				mindboxDataFinal[category] = skus
					.map(sku => {
						const product = products.find(p => p.sku === sku);
			
						if (!product) return null;
			
						const mindbox_id = product.mindbox_id || sku;
						const price = product.price?.maximum_price?.final_price?.value || 0;
			
						return { mindbox_id, price };
					})
					.filter(Boolean) as { mindbox_id: string; price: number }[];
			});

			await Promise.all([
				setMindboxProductList({
					identifier: 'cleansing_etat_pur',
					email,
					is_subscribed,
					product_list: mindboxDataFinal.cleansing_etat_pur,
					client_main_problem: [...mindboxMainProblemsSet]
				}),
				setMindboxProductList({
					identifier: 'active_care_etat_pur',
					email,
					is_subscribed: false,
					product_list: mindboxDataFinal.active_care_etat_pur
				}),
				setMindboxProductList({
					identifier: 'moisturizing_etat_pur',
					email,
					is_subscribed: false,
					product_list: mindboxDataFinal.moisturizing_etat_pur
				}),
				setMindboxProductList({
					identifier: 'sun_protection_etat_pur',
					email,
					is_subscribed: false,
					product_list: mindboxDataFinal.sun_protection_etat_pur
				})
			]);

			$form.reset();
			$form.classList.remove('_active');
			$testSubscriptionThankMsg.classList.add('_active');
		} catch (err) {
			console.error(err);
		
			const isDev = window.location.hostname.includes('localhost');
		
			if (isDev && err instanceof Error) {
				alert('Ошибка отправки:\n' + err.message);
			} else {
				alert('Не удалось отправить данные. Попробуйте позже.');
			}
		}
	}
});